import ButtonLink from 'dyl-components/atoms/ButtonLink';
import React, { useEffect, useState } from 'react';
import { Divider, Header, Icon, Loader, Pagination, Tab } from 'semantic-ui-react';
import "./index.scss";
import { useForm } from 'react-hook-form';
import OfficeViewMiddleHeader from '../OfficeViewMiddleHeader';
import OfficeViewCallResults from '../OfficeViewCallResults';
import OfficeViewCallRecording from '../OfficeViewCallRecording';
import OfficeViewRecentItem from '../OfficeViewRecentItem';

const OfficeViewRecents = ({ 
    recents,
    recentCallsCount,
    onRecentCallClick,
    recentCall,
    onCloseRecentCall,
    onEmailClick,
    setIsLogActivityModalOpen,
    logActivityForm,
    hasIntegration,
    onTaskClick,
    onHotlistClick,
    isInHotlist,
    isLogActivityModalOpen,
    onEventClick,
    isReadingRecentCalls,
    isReadingRecentCall,
    onViewMoreClick,
    onNewContactClick,
    callResultsDisabled,
    onSave,
    onMarkVoicemailAsListened,
    isUpdatingCallResults,
    onClickToDial,
    onClickToDialList,
    isPhoneSystemSupported,
    userPhoneCreds,
    callTagOptions,
    onReadRecentCalls,
    onSkipCall,
    relatedToOptions,
    callTagDisabled,
    onChangeNotes,
    onChangeResults,
    relatedToDisabled,
    totalPages,
    onReadQueuedCalls,
    queuedCalls,
    queuedCallsCount,
    onDirectCustomerClick
}) => {
    const [viewCallMode, setViewCallMode] = useState(false);
    const [isCallActivityModalOpen, setIsCallActivityModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const isQueuedPanel = activeTab === 1;
    const count = isQueuedPanel ? queuedCallsCount : recentCallsCount;

    const { control, reset, handleSubmit, formState: { isValid, isDirty } } = useForm({
        mode: "onChange",
        defaultValues: {
            call_result: null,
            call_notes: "",
            call_tag: null,
            related_to: null,
            sub_tag: null
        }
    })

    const formatPerson = () => {
        const person = recentCall ? recentCall.contact || recentCall.contacts?.[0] || recentCall.users?.[0] || null : null;
        return {
            name: isQueuedPanel ? person?.first_name + " " + person?.last_name : person?.name,
            contact_id: person?.id || person?.contact_id,
            account_id: person?.account_id,
            user_id: person?.user_id,
            archived: person?.archived,
            ...((person?.id || person?.contact_id) ? {
                contact_details: {
                    job_title: person?.job_title,
                    email: person?.email?.email || person?.email,
                    pipeline_stage: person?.pipeline,
                    phone: [{
                        main: true,
                        phone: person?.phone?.phone || person?.phone
                    }],
                    direct_customer: person.direct_customer
                }
            } : {}),
            ...(person?.account_id ? {
                account_details: {
                    customer: person?.is_customer,
                    email: person?.email?.email || person?.email,
                    account_type: person?.type || person?.account_type,
                    phone: [{
                        main: true,
                        phone: person?.phone?.phone || person?.phone
                    }]
                }
            } : {})
        }
    }
    
    useEffect(() => {
        if (recentCall) {
            const callTag = recentCall?.tags?.[0] || "";
            const [parent_value] = (callTag?.name || "").split("/");
            const parent_id = callTagOptions?.find?.(
                (item) => item?.text === parent_value
            )?.value;
            reset({
                call_notes: recentCall.note || "",
                call_result: recentCall.user_result || null,
                call_tag: parent_id,
                sub_tag: callTag?.id,
                related_to: recentCall?.related_id
            })
        } else {
            reset();
        }
    }, [recentCall])
    const isUnknown = !!recentCall?.contacts?.filter((contact) => !contact.contact_id && !contact.account_id)?.length > 0 || recentCall?.destination?.fs_destination?.substr(0,1) === '7' ;
    const unknownCnam = recentCall?.contacts?.[0]?.contact_name || recentCall?.destination?.label || ""
    const isInternalCall = recentCall?.direction === "internal";
    const [queuedCallsPage, setQueuedCallsPage] = useState(1);
    return (
        viewCallMode ? (
            !isReadingRecentCall ? (
                <div className='OfficeView__midContainer' style={{padding: "25px 35px 25px 30px"}}>
                    <OfficeViewMiddleHeader
                        person={formatPerson()}
                        onRemovePerson={() => {
                            reset();
                            setViewCallMode(false);
                            onCloseRecentCall();
                        }}
                        onEmailClick={onEmailClick}
                        setIsLogActivityModalOpen={setIsLogActivityModalOpen}
                        logActivityForm={logActivityForm}
                        unknown={{unknown: isUnknown, name: unknownCnam}}
                        hasIntegration={hasIntegration}
                        onTaskClick={onTaskClick}
                        onHotlistClick={onHotlistClick}
                        isInHotlist={isInHotlist}
                        isLogActivityModalOpen={isLogActivityModalOpen}
                        onEventClick={onEventClick}
                        onNewContactClick={onNewContactClick}
                        onClickToDial={onClickToDial}
                        isPhoneSystemSupported={isPhoneSystemSupported}
                        isCallActivityFormOpen={isCallActivityModalOpen}
                        setIsCallActivityFormOpen={setIsCallActivityModalOpen}
                        isInternalCall={isInternalCall}
                        userPhoneCreds={userPhoneCreds}
                        currentCall={{company_destination: recentCall?.destination?.fs_destination}}
                        onDirectCustomerClick={onDirectCustomerClick}
                    />
                    <div style={{marginTop: 30}}>
                        <OfficeViewCallRecording 
                            currentCallPhoneNumber={recentCall?.contact?.phone?.phone ||recentCall?.contacts?.[0]?.phone || recentCall?.users?.[0]?.extension || recentCall?.destination?.fs_destination}
                            duration={recentCall?.length}
                            callRecording={{...recentCall?.call_recording, sound_id: recentCall?.call_uuid}}
                            voicemail={recentCall?.system_result === "Missed"}
                            onMarkVoicemailAsListened={() => onMarkVoicemailAsListened?.(recentCall?.call_uuid)}
                            isInternalCall={isInternalCall}
                            isPrimaryPhone={recentCall?.contacts?.[0]?.primary}
                        />
                    </div>
                    <div>
                        {!isInternalCall && 
                            <OfficeViewCallResults
                                control={control} 
                                callResultsDisabled={callResultsDisabled}
                                recentCall={recentCall}
                                onSave={handleSubmit((data) => onSave(data, reset))}
                                onSaveDisabled={!isDirty || !isValid}
                                isSaveLoading={isUpdatingCallResults}
                                callTagOptions={callTagOptions}
                                relatedToOptions={relatedToOptions}
                                callTagDisabled={callTagDisabled}
                                onChangeNotes={onChangeNotes}
                                onChangeResults={onChangeResults}
                                relatedToDisabled={relatedToDisabled}
                            />
                        }
                    </div>
                </div>
            ) : (
                <div style={{ height: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                    <Loader active inline />
                </div>
            )
        ) : (
            <>
                <div style={{width: "100%", display: "flex", justifyContent: "center", padding:10}}>
                    <Tab
                        menu={{ color: 'primary', className: 'Dashboard__field-categories centered' }}
                        panes={[
                            { menuItem: 'Recent' },
                            { menuItem: 'Queued' },
                        ]}
                        activeIndex={activeTab}
                        onTabChange={(_, { activeIndex }) => {
                            setActiveTab(activeIndex);
                            activeIndex === 1 ? onReadQueuedCalls(1) : onReadRecentCalls();
                        }}
                    />
                </div>
                <div style={{display: 'flex', padding: "17px 0px", flexDirection: 'column'}}>
                <div style={{ overflowY: 'auto', margin: "0px 20px", height: '420px' }}>
                {!isReadingRecentCalls ? (
                    <>
                        {count === 0 && (
                            <div style={{display: 'flex', justifyContent: 'center', flex: 1, alignItems: 'center'}}>
                                <Header as={"h2"}>No {isQueuedPanel ? "Queued" : "Recent"} Calls</Header>
                            </div>
                        )}
                        {count > 0 && (
                            <div style={{flex: 1, display: 'flex', overflowY: "auto", flexDirection: 'column'}}>
                                {(isQueuedPanel ? queuedCalls : recents).map((recent) => (
                                    <OfficeViewRecentItem
                                        key={isQueuedPanel ? recent.id : recent.call_uuid}
                                        recent={recent}
                                        onRecentCallClick={() => {
                                            if (!isQueuedPanel) {
                                                onRecentCallClick(recent.call_uuid, recent.direction === "internal" ? recent.users?.[0]?.user_id : undefined, recent);
                                                setViewCallMode(true);
                                            }
                                        } }
                                        onMarkVoicemailAsListened={() => onMarkVoicemailAsListened(recent?.call_uuid)}
                                        onClickToDialList={() => {
                                            if (isQueuedPanel) {
                                                const contact = recent?.contact;
                                                onClickToDialList({
                                                    account_id: contact?.account_id,
                                                    contact_id: contact?.id,
                                                    destination: contact?.phone?.phone,
                                                    call_type: recent?.call_type,
                                                    requestor_id: recent?.id
                                                });
                                            } else {
                                                onClickToDialList(recent.contacts.length > 0 ? {
                                                    account_id: recent.contacts?.[0]?.account_id,
                                                    contact_id: recent.contacts?.[0]?.contact_id,
                                                    destination: recent.contacts?.[0]?.phone
                                                } : {
                                                    destination: recent.users?.[0]?.extension,
                                                    to_user_id: recent.users?.[0]?.user_id
                                                });
                                            }
                                        } }
                                        isPhoneSystemSupported={isPhoneSystemSupported}
                                        logActivityForm={logActivityForm}
                                        onSkipCall={isQueuedPanel ? (recent) => {onSkipCall(recent, () => {setQueuedCallsPage(1)})} : undefined}
                                    />
                                ))}
                            </div>
                        )}
                    </>
                ) : (
                    <div style={{ height: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Loader active inline />
                    </div>
                )}
                </div>
                {isQueuedPanel ? (
                    <div style={{ textAlign: 'right' }}>
                        <Divider />
                        <div style={{ paddingRight: "20px" }}>
                            <Pagination 
                                totalPages={totalPages || 1}
                                onPageChange={(_, { activePage }) => {
                                    onReadQueuedCalls(activePage);
                                    setQueuedCallsPage(activePage);
                                }}
                                activePage={queuedCallsPage || 1}
                            />
                        </div>
                    </div>
                ) : (
                    count > 0 && (
                        <div style={{paddingTop: 15, paddingLeft: 25}}>
                            <ButtonLink onClick={onViewMoreClick}>
                                <span>View More</span>
                                <Icon className='fa-solid fa-chevron-right' />
                            </ButtonLink>
                        </div>
                    )
                )}
                </div>
            </>
        )
    )
}

export default OfficeViewRecents;
